import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { Trans, useTranslation } from 'react-i18next';
import logo from './assets/logo.png';
import instagram from './assets/instagram.png';
import './LandingPage.css';

export default function LandingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [howToOpen, setHowToOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);

  return (
    <main className="landing-container" dir="rtl">
      <div className="landing-header">
        <img src={logo} alt="Chthab — جذاب" className="landing-logo" />
        <button className="play-button" onClick={() => navigate('/play')}>{t('play')}</button>
        <button className="how-to-button" onClick={() => setHowToOpen(true)}>{t('howToPlay')}</button>
      </div>
      <Modal isOpen={howToOpen} onRequestClose={() => setHowToOpen(false)}
        className="howto-modal" overlayClassName="overlay" contentLabel={t('howToTitle')}>
        <h2>{t('howToTitle')}</h2>
        {[1, 2, 3, 4, 5].map((line) => (
          <p key={line}><Trans i18nKey={`howToLine${line}`} components={{ strong: <strong /> }} /></p>
        ))}
        <p>{t('howToNote')}</p>
        <button className="modal-button" onClick={() => setHowToOpen(false)}>{t('gotIt')}</button>
      </Modal>
      <Modal isOpen={termsOpen} onRequestClose={() => setTermsOpen(false)}
        className="terms-modal" overlayClassName="overlay" contentLabel="Terms & Conditions / الشروط والأحكام">
        <h2>Terms & Conditions / الشروط والأحكام</h2>
        <p lang="en" dir="ltr">By using this game, you agree to be respectful to other players. This is a social deduction game for entertainment. Player names and roles stay on this device for the current game session and are not sent to a game server.</p>
        <p dir="rtl">باستخدامك لهذه اللعبة، توافق على احترام اللاعبين الآخرين. هذه لعبة اجتماعية للترفيه. أسماء اللاعبين وأدوارهم تبقى على هذا الجهاز خلال جلسة اللعب ولا تُرسل إلى سيرفر للعبة.</p>
        <button className="modal-button" onClick={() => setTermsOpen(false)}>{t('gotIt')}</button>
      </Modal>
      <footer className="footer-container">
        <a className="footer-instagram" href="https://www.instagram.com/playchthab" target="_blank" rel="noopener noreferrer" aria-label="Instagram — playchthab">
          <img src={instagram} alt="" />
        </a>
        <button className="footer-terms" onClick={() => setTermsOpen(true)}>Terms & Conditions / الشروط والأحكام</button>
      </footer>
    </main>
  );
}
